import * as S from '@effect/schema/Schema';
import { RealisationId } from '../realisationId';
export const Realisation = S.Struct({
    realisationId: RealisationId,
    productIds: S.Array(S.String),
    particleIds: S.Array(S.String),
    tenant: S.String,
});
